/**
 * Design tokens of the GCC executive look (WI 2461). Shared so the exported GCC
 * dashboard (@tn/ui) and the GCC TN Analysis dashboards (@tn/core) use the same
 * ink, surfaces, categorical palette, radii, shadows and easing. The brand
 * colours and the dark surfaces derived from them are in executive-palette.ts.
 *
 * A list of CSS custom property declarations, without a selector: each consumer
 * scopes it (`:root{…}` in the GCC export, `html.tn-exec{…}` in the TN dashboard).
 */
export const GCC_EXECUTIVE_TOKENS = `
  --ink:#0E1033;--ink2:#474B68;--muted:#8A8EA6;--line:#E5E7F0;--line2:#F0F1F6;
  --bg:#F3F4F9;--surface:#FFFFFF;
  --c-ret:#3F51C4;--c-gcc:#1599D6;--c-msp:#C77D2A;--c-ai:#A100FF;
  --good:#0F7B4F;--bad:#B42318;
  --r-lg:18px;--r-md:12px;--r-sm:8px;
  --sh-1:0 1px 2px rgba(14,16,51,.04),0 2px 8px rgba(14,16,51,.05);
  --sh-2:0 2px 4px rgba(14,16,51,.05),0 12px 32px rgba(14,16,51,.10);
  --ease:cubic-bezier(.2,.8,.2,1);
`
